import React, { Component } from 'react';
import Card from '../../../../components/Card';
import CardHeader from '../../../../components/CardHeader';
import styled from 'styled-components';
import Button from '../../../../components/Button';
import Table from '../../../../components/Table';
import Header from '../../../../components/Table/Header';
import Cell from '../../../../components/Cell';
import ExportButton from '../../../../components/Export';
import { I18n } from 'react-redux-i18n';

const AverageMarginCardContainer = styled.div`
  > * {
    height: calc(100% - 60px);
  }

  .exportButtonContainer {
    padding-bottom: 10px;
    margin-top: 10px;
  }
  .showAllContainer {
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
    width: 200px;
  }
`;

export default class AverageMarginCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hoverExport: false,
      sorted: [],
      showAll: false
    };
  }

  handleSort = (id) => {
    let { sorted } = this.state;
    let desc = true;
    if (sorted.length > 0 && sorted[0].id === id) {
      desc = !sorted[0].desc;
    }
    sorted = [{ id, desc }];
    this.setState({ sorted });
  };

  getOptions() {
    return [{ label: 'XLS', value: 'XLS' }];
  }

  getColumns = () => [
    {
      accessor: 'wine',
      Header: () => (
        <Header
          sortable={true}
          sort={() => this.handleSort('wine')}
          styles={`justify-content:flex-start;padding-left:30px; .title{font-size:12px}`}
          title={I18n.t('primeur.recap.marginTable.wine')}
        />
      ),
      Cell: (props) => (
        <Cell
          {...props}
          font="sfcompact_text"
          styles={`justify-content:flex-start;padding-left:30px;font-weight:600;`}
        >
          {props.value}
        </Cell>
      ),
      minWidth: 150
    },
    {
      Header: () => (
        <Header
          sortable={true}
          sort={() => this.handleSort('margin')}
          title={I18n.t('primeur.recap.marginTable.averageMargin')}
          styles={`.title{font-size:12px}`}
        />
      ),
      Cell: (props) => (
        <Cell
          {...props}
          value={
            props.value
              ? (props.value * 100).toLocaleString('fr-FR', {
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 2
                }) + '%'
              : '0 %'
          }
        />
      ),

      accessor: 'margin'
    },
    {
      Header: () => (
        <Header
          title={I18n.t('primeur.recap.marginTable.nbSeller')}
          sortable={true}
          sort={() => this.handleSort('dn')}
          styles={`.title{font-size:12px}`}
        />
      ),
      Cell: (props) => <Cell {...props}>{props.value}</Cell>,

      accessor: 'dn'
    }
  ];

  render() {
    const { data, retractedSize } = this.props;
    const { sorted, showAll } = this.state;

    const columns = this.getColumns();
    const subSetData = showAll
      ? data
      : data && data.length > 0
        ? data.slice(0, retractedSize)
        : [];

    return (
      <AverageMarginCardContainer>
        <Card id="marge-moyenne-recap">
          <CardHeader
            title={I18n.t('primeur.recap.marginTable.title')}
            fontSize={'20px'}
            alignItems="center"
            iconRight
            rightComponents={
              <ExportButton
                jpg
                pdf
                name="marge-moyenne-recap"
                targetElement="#marge-moyenne-recap"
              />
            }
          />
          <Table
            data={subSetData}
            columns={columns}
            sorted={sorted}
            subRowsKey={null}
          />
          <div className="showAllContainer ignored-export">
            {!showAll && data.length > retractedSize && (
              <Button
                width="200px"
                label={`${I18n.t('seeMore')} (+${data.length - retractedSize})`}
                color="white"
                textColor="black"
                textTransform="normal"
                border="0.8px black solid"
                fontFamily="SFCompactText"
                fontSize="12px !important"
                onClick={() => this.setState({ showAll: true })}
              />
            )}
            {showAll && data.length > retractedSize && (
              <Button
                width="200px"
                label={I18n.t('seeLess')}
                color="white"
                textColor="black"
                textTransform="normal"
                border="0.8px black solid"
                fontFamily="SFCompactText"
                fontSize="12px !important"
                onClick={() => this.setState({ showAll: false })}
              />
            )}
          </div>
        </Card>
      </AverageMarginCardContainer>
    );
  }
}
